import React, { memo, useCallback, useEffect, useRef } from 'react'
import { useRealAmap, labelMarkersPlugin, Layer } from '@ow/maps/lib'
import markerIcon from '../assets/marker.svg'

const mapConfig = {
  center: [116.478935, 39.997761],
  zoom: 15,
  mapStyle: 'darkblue',
  // getLayers: (AMap) => [new AMap.TileLayer.Satellite()]
}

const icon = {
  type: 'image',
  // 图片 url
  image: markerIcon,
  // 图片尺寸
  size: [30, 30],
}

const mapContainerId = 'viewmap-screen'

const Map = ({ data, onMarkerClick }) => {
  const markersLayer = useRef(new Layer(null, {}))
  const { inited } = useRealAmap(
    mapContainerId,
    {
      amapKey: '0e4f7b5e424e7db93755cb5d48e71a75',
      plugins: [labelMarkersPlugin()],
      ...mapConfig,
    },
    ({ getApis }) => {
      const { initLabelMarker } = getApis()
      initLabelMarker(markersLayer.current)
    }
  )

  const renderData = useCallback(
    (_data) => {
      markersLayer.current.clear()
      markersLayer.current.render(_data, {
        icon,
        onClick: onMarkerClick,
      })
    },
    [onMarkerClick]
  )

  useEffect(() => {
    if (!inited) return

    renderData(data)
  }, [inited, data])

  return <div id={mapContainerId} className="w-full h-full" />
}

export default memo(Map)
